import { provinceAndCityData } from '@/components//FormGen/FormItem/ProvinceCity/data'

export const conditionOptions = [
  {
    value: 'eq',
    label: '选中'
  },
  // {
  //   value: 'ne',
  //   label: '未选中'
  // },
  {
    value: 'gt',
    label: '大于',
    types: ['RATE']
  },
  {
    value: 'ge',
    label: '大于等于',
    types: ['RATE']
  },
  {
    value: 'lt',
    label: '小于',
    types: ['RATE']
  },
  {
    value: 'le',
    label: '小于等于',
    types: ['RATE']
  }
]
export const parameterOptions = [
  {
    value: 'include',
    label: '包含'
  },
  {
    value: 'uninclude',
    label: '不包含'
  }
]

let cityList = []
// 计算市
provinceAndCityData.forEach((item) =>
  item.children.map((cItem) => {
    if (cItem.label === '市辖区') {
      cItem.label = item.label
    }
    cityList.push(cItem)
  })
)

export const parameterChildList = [
  {
    value: 'product',
    label: '菜品编码',
    eleType: 'input',
    placeholderText: '请输入菜品编码'
  },
  {
    value: 'code',
    label: '门店编码',
    eleType: 'input',
    placeholderText: '请输入门店编码'
  },
  {
    value: 'province',
    label: '省份',
    eleType: 'select',
    options: provinceAndCityData,
    placeholderText: '请选择省份'
  },
  {
    value: 'city',
    label: '城市',
    eleType: 'select',
    options: cityList,
    placeholderText: '请选择城市'
  }
]
